/*
 * @Author: Tahiti
 * @Date: 2025-12-04
 * @Description: 灵感相关多语言文案
 * @FilePath: /weryai-web/locales/modules/inspiration.ts
 */
export default {
    zh: {
        // 标题
        title: '灵感',
        // 分类标签
        categoryAll: '全部',
        categoryHot: '热门',
        categoryLatest: '最新',
        categoryRecentlyUsed: '最近使用',

        // Tab 标签
        tabHistory: '历史',
        tabInspiration: '灵感',
        tabHistoryMobile: '历史记录',
        tabInspirationMobile: '灵感广场',

        // 操作按钮
        createSimilar: '创建类似图像',

        // 状态提示
        noMoreData: '没有更多了',
        noData: '暂无数据 :D',
        noInspirationData: '暂无灵感数据',
        loading: '加载中...',
        loadingMore: '加载更多...',
        detecting: '检测中',
        operationFailed: '操作失败',
        likeFailed: '点赞失败，请稍后重试',

        // 用户信息
        unknownUser: '未知用户',

        // 菜单操作
        download: '下载',
        downloadWithWatermark: '有水印下载',
        downloadWithoutWatermark: '无水印下载',
        share: '分享',
        copyLink: '复制链接',
        report: '报告',

        // 下载提示
        preparingDownload: '正在准备下载...',
        downloadFailed: '下载失败，请稍后重试',
        vipRequired: '无水印下载需要 VIP 会员',
        noWatermarkUrlNotAvailable: '无水印下载链接不可用',
        copySuccess: '复制成功',
        copyFailed: '复制失败',
        copyPrompt: '复制提示词',
        copyLyrics: '复制歌词',

        // 详情页
        originalImage: '原图',
        prompt: '提示词',
        model: '模型',
        style: '风格',
        aspectRatio: '长宽比',
        outputSize: '输出尺寸',
        tags: '标签',
        generateSimilar: '做同款',
        image: '图像',
        video: '视频',
        creations: '创作',
        creationDetail: '创作详情',
        aiImageCreation: 'AI 图片创作',
        aiVideoCreation: 'AI 视频创作',
        aiMusicCreation: 'AI 音乐创作',
        aiGeneratedContent: 'AI 生成内容',
        anonymous: '匿名用户',

        // 生成类型
        imageToVideo: '图生视频',
        imageToImage: '图生图',
        generate: '生成',
        auto: '自动',

        // 音乐分享相关
        musicStyle: '音乐风格',
        lyrics: '歌词',
        untitledMusic: '未命名音乐',
        noLyrics: '暂无歌词',
        noAudio: '暂无音频',
        referenceAudio: '参考音频',
        playFailed: '播放失败，请稍后重试',
        audioLoadFailed: '音频加载失败',
        shareSuccess: '分享链接已复制',
        shareFailed: '分享失败，请稍后重试',
        noShareableContent: '暂无可分享内容',
        noPrompt: '暂无提示词',
        type: '类型',
        createTime: '时间',
        expandDetails: '展开详细信息',
        collapseDetails: '收起详细信息',
        userAvatar: '{name}的头像',
        defaultAvatar: '用户头像',
        aiGenerated: '使用 {model} 生成的 AI {type}: {prompt}',
    },
    en: {
        // Title
        title: 'Inspiration',
        // Category labels
        categoryAll: 'All',
        categoryHot: 'Hot',
        categoryLatest: 'Latest',
        categoryRecentlyUsed: 'Recently Used',

        // Tab labels
        tabHistory: 'History',
        tabInspiration: 'Inspiration',
        tabHistoryMobile: 'History',
        tabInspirationMobile: 'Inspiration Square',

        // Action buttons
        createSimilar: 'Create Similar',

        // Status messages
        noMoreData: 'No more data',
        noData: 'No data available :D',
        noInspirationData: 'No inspiration data',
        loading: 'Loading...',
        loadingMore: 'Loading more...',
        detecting: 'Detecting',
        operationFailed: 'Operation failed',
        likeFailed: 'Like failed, please try again later',

        // User info
        unknownUser: 'Unknown',

        // Menu actions
        download: 'Download',
        downloadWithWatermark: 'With Watermark',
        downloadWithoutWatermark: 'Without Watermark',
        share: 'Share',
        copyLink: 'Copy Link',
        report: 'Report',

        // Download notifications
        preparingDownload: 'Preparing download...',
        downloadFailed: 'Download failed, please try again',
        vipRequired: 'VIP membership required for no-watermark download',
        noWatermarkUrlNotAvailable: 'No watermark download link available',
        copySuccess: 'Copied successfully',
        copyFailed: 'Copy failed',
        copyPrompt: 'Copy prompt',
        copyLyrics: 'Copy Lyrics',

        // Detail page
        originalImage: 'Original',
        prompt: 'Prompt',
        model: 'Model',
        style: 'Style',
        aspectRatio: 'Aspect Ratio',
        outputSize: 'Output Size',
        tags: 'Tags',
        generateSimilar: 'Remix',
        image: 'Image',
        video: 'Video',
        creations: 'Creations',
        creationDetail: 'Creation Detail',
        aiImageCreation: 'AI Image Creation',
        aiVideoCreation: 'AI Video Creation',
        aiMusicCreation: 'AI Music Creation',
        aiGeneratedContent: 'AI Generated Content',
        anonymous: 'Anonymous',

        // Generation types
        imageToVideo: 'Image to Video',
        imageToImage: 'Image to Image',
        generate: 'Generate',
        auto: 'Auto',

        // Music sharing
        musicStyle: 'Music Style',
        lyrics: 'Lyrics',
        untitledMusic: 'Untitled Music',
        noLyrics: 'No lyrics available',
        noAudio: 'No audio available',
        referenceAudio: 'Reference Audio',
        playFailed: 'Playback failed, please try again',
        audioLoadFailed: 'Audio load failed',
        shareSuccess: 'Share link copied',
        shareFailed: 'Share failed, please try again',
        noShareableContent: 'No shareable content',
        noPrompt: 'No prompt available',
        type: 'Type',
        createTime: 'Time',
        expandDetails: 'Expand Details',
        collapseDetails: 'Collapse Details',
        userAvatar: "{name}'s avatar",
        defaultAvatar: 'User avatar',
        aiGenerated: 'AI generated {type} using {model}: {prompt}',
    },
    ja: {
        // タイトル
        title: 'インスピレーション',
        // カテゴリーラベル
        categoryAll: 'すべて',
        categoryHot: '人気',
        categoryLatest: '最新',
        categoryRecentlyUsed: '最近使用',

        // タブラベル
        tabHistory: '履歴',
        tabInspiration: 'インスピレーション',

        // アクションボタン
        createSimilar: '類似画像を作成',

        // ステータスメッセージ
        noMoreData: 'これ以上データがありません',
        noData: 'データがありません :D',
        noInspirationData: 'インスピレーションデータがありません',
        loading: '読み込み中...',
        loadingMore: 'もっと読み込む...',
        detecting: '検出中',
        operationFailed: '操作に失敗しました',
        likeFailed: 'いいねに失敗しました、後でもう一度お試しください',

        // ユーザー情報
        unknownUser: '不明',

        // メニューアクション
        download: 'ダウンロード',
        downloadWithWatermark: '透かし入り',
        downloadWithoutWatermark: '透かしなし',
        share: '共有',
        copyLink: 'リンクをコピー',
        report: '報告',

        // ダウンロード通知
        preparingDownload: 'ダウンロードを準備中...',
        downloadFailed: 'ダウンロードに失敗しました',
        vipRequired: 'ウォーターマークなしのダウンロードにはVIPが必要です',
        noWatermarkUrlNotAvailable:
            'ウォーターマークなしのリンクが利用できません',
        copySuccess: 'コピーしました',
        copyFailed: 'コピーに失敗しました',
        copyLyrics: '歌詞をコピー',

        // 詳細ページ
        originalImage: '元の画像',
        prompt: 'プロンプト',
        model: 'モデル',
        style: 'スタイル',
        aspectRatio: 'アスペクト比',
        outputSize: '出力サイズ',
        tags: 'タグ',
        generateSimilar: '同じスタイルを作る',
        image: '画像',
        video: 'ビデオ',
        creations: '作品',
        creationDetail: '作品詳細',
        aiImageCreation: 'AI 画像生成',
        aiVideoCreation: 'AI 動画生成',
        aiMusicCreation: 'AI 音楽生成',
        aiGeneratedContent: 'AI 生成コンテンツ',
        anonymous: '匿名ユーザー',

        // 生成タイプ
        imageToVideo: '画像から動画',
        imageToImage: '画像から画像',
        generate: '生成',
        auto: '自動',

        // 音楽共有
        musicStyle: '音楽スタイル',
        lyrics: '歌詞',
        untitledMusic: '無題の音楽',
        noLyrics: '歌詞がありません',
        noAudio: '音声がありません',
        referenceAudio: '参照オーディオ',
        playFailed: '再生に失敗しました',
        audioLoadFailed: '音声の読み込みに失敗しました',
        shareSuccess: '共有リンクをコピーしました',
        shareFailed: '共有に失敗しました',
        noShareableContent: '共有できるコンテンツがありません',
        copyPrompt: 'プロンプトをコピー',
        noPrompt: 'プロンプトがありません',
        type: 'タイプ',
        createTime: '時間',
        expandDetails: '詳細を展開',
        collapseDetails: '詳細を折りたたむ',
    },
    ko: {
        // 제목
        title: '영감',
        // 카테고리 레이블
        categoryAll: '모두',
        categoryHot: '인기',
        categoryLatest: '최신',
        categoryRecentlyUsed: '최근 사용',

        // 탭 레이블
        tabHistory: '기록',
        tabInspiration: '영감',

        // 액션 버튼
        createSimilar: '유사한 이미지 생성',

        // 상태 메시지
        noMoreData: '더 이상 데이터가 없습니다',
        noData: '데이터가 없습니다 :D',
        noInspirationData: '영감 데이터가 없습니다',
        loading: '로딩 중...',
        loadingMore: '더 불러오는 중...',
        detecting: '감지 중',
        operationFailed: '작업 실패',
        likeFailed: '좋아요 실패, 나중에 다시 시도해주세요',

        // 사용자 정보
        unknownUser: '알 수 없음',

        // 메뉴 액션
        download: '다운로드',
        downloadWithWatermark: '워터마크 포함',
        downloadWithoutWatermark: '워터마크 없음',
        share: '공유',
        copyLink: '링크 복사',
        report: '신고',

        // 다운로드 알림
        preparingDownload: '다운로드 준비 중...',
        downloadFailed: '다운로드 실패, 다시 시도해주세요',
        vipRequired: '워터마크 없는 다운로드는 VIP만 가능합니다',
        noWatermarkUrlNotAvailable: '워터마크 없는 링크를 사용할 수 없습니다',
        copySuccess: '복사 성공',
        copyFailed: '복사 실패',
        copyLyrics: '가사 복사',

        // 상세 페이지
        originalImage: '원본 이미지',
        prompt: '프롬프트',
        model: '모델',
        style: '스타일',
        aspectRatio: '비율',
        outputSize: '출력 크기',
        tags: '태그',
        generateSimilar: '같은 스타일 만들기',
        image: '이미지',
        video: '비디오',
        creations: '창작물',
        creationDetail: '창작물 상세',
        aiImageCreation: 'AI 이미지 생성',
        aiVideoCreation: 'AI 동영상 생성',
        aiMusicCreation: 'AI 음악 생성',
        aiGeneratedContent: 'AI 생성 콘텐츠',
        anonymous: '익명 사용자',

        // 생성 유형
        imageToVideo: '이미지를 비디오로',
        imageToImage: '이미지를 이미지로',
        generate: '생성',
        auto: '자동',

        // 음악 공유
        musicStyle: '음악 스타일',
        lyrics: '가사',
        untitledMusic: '제목 없는 음악',
        noLyrics: '가사가 없습니다',
        noAudio: '오디오가 없습니다',
        referenceAudio: '참조 오디오',
        playFailed: '재생 실패, 다시 시도해주세요',
        audioLoadFailed: '오디오 로드 실패',
        shareSuccess: '공유 링크가 복사되었습니다',
        shareFailed: '공유 실패, 다시 시도해주세요',
        noShareableContent: '공유할 콘텐츠가 없습니다',
        copyPrompt: '프롬프트 복사',
        noPrompt: '프롬프트 없음',
        type: '유형',
        createTime: '시간',
        expandDetails: '상세 정보 펼치기',
        collapseDetails: '상세 정보 접기',
    },
    es: {
        // Título
        title: 'Inspiración',
        // Etiquetas de categoría
        categoryAll: 'Todos',
        categoryHot: 'Popular',
        categoryLatest: 'Último',
        categoryRecentlyUsed: 'Usado Recientemente',

        // Etiquetas de pestaña
        tabHistory: 'Historial',
        tabInspiration: 'Inspiración',

        // Botones de acción
        createSimilar: 'Crear Similar',

        // Mensajes de estado
        noMoreData: 'No hay más datos',
        noData: 'No hay datos :D',
        noInspirationData: 'No hay datos de inspiración',
        loading: 'Cargando...',
        loadingMore: 'Cargando más...',
        detecting: 'Detectando',
        operationFailed: 'Operación fallida',
        likeFailed: 'Error al dar me gusta, inténtelo más tarde',

        // Información del usuario
        unknownUser: 'Desconocido',

        // Acciones del menú
        download: 'Descargar',
        downloadWithWatermark: 'Con Marca de Agua',
        downloadWithoutWatermark: 'Sin Marca de Agua',
        share: 'Compartir',
        copyLink: 'Copiar Enlace',
        report: 'Reportar',

        // Notificaciones de descarga
        preparingDownload: 'Preparando descarga...',
        downloadFailed: 'Descarga fallida, intente de nuevo',
        vipRequired: 'Se requiere VIP para descargar sin marca de agua',
        noWatermarkUrlNotAvailable:
            'Enlace de descarga sin marca de agua no disponible',
        copySuccess: 'Copiado exitosamente',
        copyFailed: 'Copia fallida',
        copyLyrics: 'Copiar letra',

        // Página de detalles
        originalImage: 'Original',
        prompt: 'Prompt',
        model: 'Modelo',
        style: 'Estilo',
        aspectRatio: 'Relación de Aspecto',
        outputSize: 'Tamaño de Salida',
        tags: 'Etiquetas',
        generateSimilar: 'Hacer lo mismo',
        image: 'Imagen',
        video: 'Video',
        creations: 'Creaciones',
        creationDetail: 'Detalle de Creación',
        aiImageCreation: 'Creación de Imagen IA',
        aiVideoCreation: 'Creación de Video IA',
        aiMusicCreation: 'Creación de Música IA',
        aiGeneratedContent: 'Contenido Generado por IA',
        anonymous: 'Anónimo',

        // Tipos de generación
        imageToVideo: 'Imagen a Video',
        imageToImage: 'Imagen a Imagen',
        generate: 'Generar',
        auto: 'Auto',

        // Compartir música
        musicStyle: 'Estilo Musical',
        lyrics: 'Letra',
        untitledMusic: 'Música sin título',
        noLyrics: 'Sin letra disponible',
        noAudio: 'Sin audio disponible',
        referenceAudio: 'Audio de referencia',
        playFailed: 'Reproducción fallida, intente de nuevo',
        audioLoadFailed: 'Error al cargar el audio',
        shareSuccess: 'Enlace copiado',
        shareFailed: 'Error al compartir, intente de nuevo',
        noShareableContent: 'Sin contenido para compartir',
        copyPrompt: 'Copiar prompt',
        noPrompt: 'Sin prompt disponible',
        type: 'Tipo',
        createTime: 'Tiempo',
        expandDetails: 'Expandir Detalles',
        collapseDetails: 'Contraer Detalles',
    },
    fr: {
        // Titre
        title: 'Inspiration',
        // Étiquettes de catégorie
        categoryAll: 'Tous',
        categoryHot: 'Populaire',
        categoryLatest: 'Dernier',
        categoryRecentlyUsed: 'Récemment Utilisé',

        // Étiquettes d'onglet
        tabHistory: 'Historique',
        tabInspiration: 'Inspiration',

        // Boutons d'action
        createSimilar: 'Créer Similaire',

        // Messages d'état
        noMoreData: 'Plus de données',
        noData: 'Aucune donnée :D',
        noInspirationData: "Aucune donnée d'inspiration",
        loading: 'Chargement...',
        loadingMore: 'Chargement de plus...',
        detecting: 'Détection',
        operationFailed: 'Opération échouée',
        likeFailed: 'Échec du like, veuillez réessayer plus tard',

        // Informations utilisateur
        unknownUser: 'Inconnu',

        // Actions du menu
        download: 'Télécharger',
        downloadWithWatermark: 'Avec Filigrane',
        downloadWithoutWatermark: 'Sans Filigrane',
        share: 'Partager',
        copyLink: 'Copier le Lien',
        report: 'Signaler',

        // Notifications de téléchargement
        preparingDownload: 'Préparation du téléchargement...',
        downloadFailed: 'Échec du téléchargement, réessayez',
        vipRequired:
            'Un abonnement VIP est requis pour télécharger sans filigrane',
        noWatermarkUrlNotAvailable:
            'Lien de téléchargement sans filigrane indisponible',
        copySuccess: 'Copié avec succès',
        copyFailed: 'Échec de la copie',
        copyLyrics: 'Copier les paroles',

        // Page de détails
        originalImage: 'Original',
        prompt: 'Prompt',
        model: 'Modèle',
        style: 'Style',
        aspectRatio: "Rapport d'Aspect",
        outputSize: 'Taille de Sortie',
        tags: 'Tags',
        generateSimilar: 'Faire le même',
        image: 'Image',
        video: 'Vidéo',
        creations: 'Créations',
        creationDetail: 'Détail de Création',
        aiImageCreation: "Création d'Image IA",
        aiVideoCreation: 'Création de Vidéo IA',
        aiMusicCreation: 'Création de Musique IA',
        aiGeneratedContent: 'Contenu Généré par IA',
        anonymous: 'Anonyme',

        // Types de génération
        imageToVideo: 'Image à Vidéo',
        imageToImage: 'Image à Image',
        generate: 'Générer',
        auto: 'Auto',

        // Partage de musique
        musicStyle: 'Style Musical',
        lyrics: 'Paroles',
        untitledMusic: 'Musique sans titre',
        noLyrics: 'Aucune parole disponible',
        noAudio: 'Aucun audio disponible',
        referenceAudio: 'Audio de référence',
        playFailed: 'Échec de lecture, veuillez réessayer',
        audioLoadFailed: 'Échec du chargement audio',
        shareSuccess: 'Lien de partage copié',
        shareFailed: 'Échec du partage, veuillez réessayer',
        noShareableContent: 'Aucun contenu partageable',
        copyPrompt: 'Copier le prompt',
        noPrompt: 'Aucun prompt disponible',
        type: 'Type',
        createTime: 'Temps',
        expandDetails: 'Plus de Détails',
        collapseDetails: 'Moins de Détails',
    },
    de: {
        // Titel
        title: 'Inspiration',
        // Kategoriebezeichnungen
        categoryAll: 'Alle',
        categoryHot: 'Beliebt',
        categoryLatest: 'Neueste',
        categoryRecentlyUsed: 'Kürzlich Verwendet',

        // Tab-Bezeichnungen
        tabHistory: 'Verlauf',
        tabInspiration: 'Inspiration',

        // Aktionsschaltflächen
        createSimilar: 'Ähnliches Erstellen',

        // Statusmeldungen
        noMoreData: 'Keine weiteren Daten',
        noData: 'Keine Daten :D',
        noInspirationData: 'Keine Inspirationsdaten',
        loading: 'Wird geladen...',
        loadingMore: 'Mehr laden...',
        detecting: 'Erkennen',
        operationFailed: 'Vorgang fehlgeschlagen',
        likeFailed: 'Like fehlgeschlagen, bitte später erneut versuchen',

        // Benutzerinformationen
        unknownUser: 'Unbekannt',

        // Menü-Aktionen
        download: 'Herunterladen',
        downloadWithWatermark: 'Mit Wasserzeichen',
        downloadWithoutWatermark: 'Ohne Wasserzeichen',
        share: 'Teilen',
        copyLink: 'Link Kopieren',
        report: 'Melden',

        // Download-Benachrichtigungen
        preparingDownload: 'Download wird vorbereitet...',
        downloadFailed: 'Download fehlgeschlagen, bitte erneut versuchen',
        vipRequired: 'VIP erforderlich für Downloads ohne Wasserzeichen',
        noWatermarkUrlNotAvailable: 'Link ohne Wasserzeichen nicht verfügbar',
        copySuccess: 'Erfolgreich kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        copyLyrics: 'Liedtext kopieren',

        // Detailseite
        originalImage: 'Original',
        prompt: 'Prompt',
        model: 'Modell',
        style: 'Stil',
        aspectRatio: 'Seitenverhältnis',
        outputSize: 'Ausgabegröße',
        tags: 'Tags',
        generateSimilar: 'Das Gleiche machen',
        image: 'Bild',
        video: 'Video',
        creations: 'Kreationen',
        creationDetail: 'Kreationsdetail',
        aiImageCreation: 'KI-Bilderzeugung',
        aiVideoCreation: 'KI-Videoerzeugung',
        aiMusicCreation: 'KI-Musikerzeugung',
        aiGeneratedContent: 'KI-generierter Inhalt',
        anonymous: 'Anonym',

        // Generierungstypen
        imageToVideo: 'Bild zu Video',
        imageToImage: 'Bild zu Bild',
        generate: 'Generieren',
        auto: 'Auto',

        // Musik teilen
        musicStyle: 'Musikstil',
        lyrics: 'Liedtext',
        untitledMusic: 'Unbenannte Musik',
        noLyrics: 'Kein Liedtext verfügbar',
        noAudio: 'Kein Audio verfügbar',
        referenceAudio: 'Referenzaudio',
        playFailed: 'Wiedergabe fehlgeschlagen, bitte erneut versuchen',
        audioLoadFailed: 'Audio-Laden fehlgeschlagen',
        shareSuccess: 'Freigabelink kopiert',
        shareFailed: 'Teilen fehlgeschlagen, bitte erneut versuchen',
        noShareableContent: 'Kein teilbarer Inhalt',
        copyPrompt: 'Prompt kopieren',
        noPrompt: 'Kein Prompt verfügbar',
        type: 'Typ',
        createTime: 'Zeit',
        expandDetails: 'Details Anzeigen',
        collapseDetails: 'Details Ausblenden',
    },
    ru: {
        // Заголовок
        title: 'Вдохновение',
        // Метки категорий
        categoryAll: 'Все',
        categoryHot: 'Популярное',
        categoryLatest: 'Последние',
        categoryRecentlyUsed: 'Недавно Использованные',

        // Метки вкладок
        tabHistory: 'История',
        tabInspiration: 'Вдохновение',

        // Кнопки действий
        createSimilar: 'Создать Похожее',

        // Сообщения о состоянии
        noMoreData: 'Больше нет данных',
        noData: 'Нет данных :D',
        noInspirationData: 'Нет данных для вдохновения',
        loading: 'Загрузка...',
        loadingMore: 'Загрузка еще...',
        detecting: 'Обнаружение',
        operationFailed: 'Операция не удалась',
        likeFailed: 'Не удалось поставить лайк, попробуйте позже',

        // Информация о пользователе
        unknownUser: 'Неизвестно',

        // Действия меню
        download: 'Скачать',
        downloadWithWatermark: 'С Водяным Знаком',
        downloadWithoutWatermark: 'Без Водяного Знака',
        share: 'Поделиться',
        copyLink: 'Копировать Ссылку',
        report: 'Пожаловаться',

        // Уведомления загрузки
        preparingDownload: 'Подготовка загрузки...',
        downloadFailed: 'Загрузка не удалась, попробуйте снова',
        vipRequired: 'Для загрузки без водяного знака нужен VIP',
        noWatermarkUrlNotAvailable:
            'Ссылка для загрузки без водяного знака недоступна',
        copySuccess: 'Успешно скопировано',
        copyFailed: 'Не удалось скопировать',
        copyLyrics: 'Копировать текст',

        // Страница деталей
        originalImage: 'Оригинал',
        prompt: 'Промпт',
        model: 'Модель',
        style: 'Стиль',
        aspectRatio: 'Соотношение Сторон',
        outputSize: 'Размер Вывода',
        tags: 'Теги',
        generateSimilar: 'Сделать такой же',
        image: 'Изображение',
        video: 'Видео',
        creations: 'Творения',
        creationDetail: 'Детали творения',
        aiImageCreation: 'Создание AI-изображения',
        aiVideoCreation: 'Создание AI-видео',
        aiMusicCreation: 'Создание AI-музыки',
        aiGeneratedContent: 'Контент, созданный ИИ',
        anonymous: 'Аноним',

        // Типы генерации
        imageToVideo: 'Изображение в Видео',
        imageToImage: 'Изображение в Изображение',
        generate: 'Генерировать',
        auto: 'Авто',

        // Поделиться музыкой
        musicStyle: 'Музыкальный стиль',
        lyrics: 'Текст песни',
        untitledMusic: 'Без названия',
        noLyrics: 'Текст недоступен',
        noAudio: 'Аудио недоступно',
        referenceAudio: 'Референсное аудио',
        playFailed: 'Ошибка воспроизведения',
        audioLoadFailed: 'Ошибка загрузки аудио',
        shareSuccess: 'Ссылка скопирована',
        shareFailed: 'Ошибка при поделении',
        noShareableContent: 'Нет контента для публикации',
        copyPrompt: 'Копировать промпт',
        noPrompt: 'Промпт отсутствует',
        type: 'Тип',
        createTime: 'Время',
        expandDetails: 'Развернуть',
        collapseDetails: 'Свернуть',
    },
    pt: {
        // Título
        title: 'Inspiração',
        // Rótulos de categoria
        categoryAll: 'Todos',
        categoryHot: 'Popular',
        categoryLatest: 'Último',
        categoryRecentlyUsed: 'Usado Recentemente',

        // Rótulos de guia
        tabHistory: 'Histórico',
        tabInspiration: 'Inspiração',

        // Botões de ação
        createSimilar: 'Criar Similar',

        // Mensagens de status
        noMoreData: 'Sem mais dados',
        noData: 'Sem dados :D',
        noInspirationData: 'Sem dados de inspiração',
        loading: 'Carregando...',
        loadingMore: 'Carregando mais...',
        detecting: 'Detectando',
        operationFailed: 'Operação falhou',
        likeFailed: 'Falha ao curtir, tente novamente mais tarde',

        // Informações do usuário
        unknownUser: 'Desconhecido',

        // Ações do menu
        download: 'Baixar',
        downloadWithWatermark: "Com Marca d'Água",
        downloadWithoutWatermark: "Sem Marca d'Água",
        share: 'Compartilhar',
        copyLink: 'Copiar Link',
        report: 'Denunciar',

        // Notificações de download
        preparingDownload: 'Preparando download...',
        downloadFailed: 'Falha no download, tente novamente',
        vipRequired: "É necessário ser VIP para baixar sem marca d'água",
        noWatermarkUrlNotAvailable:
            "Link para download sem marca d'água indisponível",
        copySuccess: 'Copiado com sucesso',
        copyFailed: 'Falha ao copiar',
        copyLyrics: 'Copiar letra',

        // Página de detalhes
        originalImage: 'Original',
        prompt: 'Prompt',
        model: 'Modelo',
        style: 'Estilo',
        aspectRatio: 'Proporção',
        outputSize: 'Tamanho de Saída',
        tags: 'Tags',
        generateSimilar: 'Fazer o mesmo',
        image: 'Imagem',
        video: 'Vídeo',
        creations: 'Criações',
        creationDetail: 'Detalhes da Criação',
        aiImageCreation: 'Criação de Imagem IA',
        aiVideoCreation: 'Criação de Vídeo IA',
        aiMusicCreation: 'Criação de Música IA',
        aiGeneratedContent: 'Conteúdo Gerado por IA',
        anonymous: 'Anônimo',

        // Tipos de geração
        imageToVideo: 'Imagem para Vídeo',
        imageToImage: 'Imagem para Imagem',
        generate: 'Gerar',
        auto: 'Auto',

        // Compartilhamento de música
        musicStyle: 'Estilo Musical',
        lyrics: 'Letra',
        untitledMusic: 'Música sem título',
        noLyrics: 'Sem letra disponível',
        noAudio: 'Sem áudio disponível',
        referenceAudio: 'Áudio de referência',
        playFailed: 'Falha na reprodução, tente novamente',
        audioLoadFailed: 'Falha ao carregar áudio',
        shareSuccess: 'Link de compartilhamento copiado',
        shareFailed: 'Falha ao compartilhar, tente novamente',
        noShareableContent: 'Sem conteúdo para compartilhar',
        copyPrompt: 'Copiar prompt',
        noPrompt: 'Nenhum prompt disponível',
        type: 'Tipo',
        createTime: 'Tempo',
        expandDetails: 'Expandir Detalhes',
        collapseDetails: 'Recolher Detalhes',
    },
    it: {
        // Titolo
        title: 'Ispirazione',
        // Etichette di categoria
        categoryAll: 'Tutti',
        categoryHot: 'Popolare',
        categoryLatest: 'Ultimo',
        categoryRecentlyUsed: 'Usato di Recente',

        // Etichette scheda
        tabHistory: 'Cronologia',
        tabInspiration: 'Ispirazione',

        // Pulsanti d\'azione
        createSimilar: 'Crea Simile',

        // Messaggi di stato
        noMoreData: 'Nessun altro dato',
        noData: 'Nessun dato :D',
        noInspirationData: 'Nessun dato di ispirazione',
        loading: 'Caricamento...',
        loadingMore: 'Caricamento di più...',
        detecting: 'Rilevamento',
        operationFailed: 'Operazione fallita',
        likeFailed: 'Mi piace non riuscito, riprova più tardi',

        // Informazioni utente
        unknownUser: 'Sconosciuto',

        // Azioni del menu
        download: 'Scarica',
        downloadWithWatermark: 'Con Filigrana',
        downloadWithoutWatermark: 'Senza Filigrana',
        share: 'Condividi',
        copyLink: 'Copia Link',
        report: 'Segnala',

        // Notifiche download
        preparingDownload: 'Preparazione download...',
        downloadFailed: 'Download fallito, riprova',
        vipRequired: 'Serve VIP per scaricare senza filigrana',
        noWatermarkUrlNotAvailable:
            'Link per download senza filigrana non disponibile',
        copySuccess: 'Copiato con successo',
        copyFailed: 'Copia fallita',
        copyLyrics: 'Copia testo',

        // Pagina dettagli
        originalImage: 'Originale',
        prompt: 'Prompt',
        model: 'Modello',
        style: 'Stile',
        aspectRatio: 'Proporzioni',
        outputSize: 'Dimensione Output',
        tags: 'Tag',
        generateSimilar: 'Fare lo stesso',
        image: 'Immagine',
        video: 'Video',
        creations: 'Creazioni',
        creationDetail: 'Dettaglio Creazione',
        aiImageCreation: 'Creazione Immagine IA',
        aiVideoCreation: 'Creazione Video IA',
        aiMusicCreation: 'Creazione Musica IA',
        aiGeneratedContent: 'Contenuto Generato da IA',
        anonymous: 'Anonimo',

        // Tipi di generazione
        imageToVideo: 'Immagine a Video',
        imageToImage: 'Immagine a Immagine',
        generate: 'Genera',
        auto: 'Auto',

        // Condivisione musicale
        musicStyle: 'Stile Musicale',
        lyrics: 'Testo',
        untitledMusic: 'Musica senza titolo',
        noLyrics: 'Nessun testo disponibile',
        noAudio: 'Nessun audio disponibile',
        referenceAudio: 'Audio di riferimento',
        playFailed: 'Riproduzione fallita, riprova',
        audioLoadFailed: 'Caricamento audio fallito',
        shareSuccess: 'Link di condivisione copiato',
        shareFailed: 'Condivisione fallita, riprova',
        noShareableContent: 'Nessun contenuto condivisibile',
        copyPrompt: 'Copia prompt',
        noPrompt: 'Nessun prompt disponibile',
        type: 'Tipo',
        createTime: 'Tempo',
        expandDetails: 'Espandi Dettagli',
        collapseDetails: 'Comprimi Dettagli',
    },
    ar: {
        // العنوان
        title: 'إلهام',
        // تسميات الفئة
        categoryAll: 'الكل',
        categoryHot: 'شائع',
        categoryLatest: 'الأحدث',
        categoryRecentlyUsed: 'المستخدم مؤخرًا',

        // تسميات التبويب
        tabHistory: 'السجل',
        tabInspiration: 'إلهام',

        // أزرار الإجراء
        createSimilar: 'إنشاء مماثل',

        // رسائل الحالة
        noMoreData: 'لا مزيد من البيانات',
        noData: 'لا توجد بيانات :D',
        noInspirationData: 'لا توجد بيانات إلهام',
        loading: 'جارٍ التحميل...',
        loadingMore: 'تحميل المزيد...',
        detecting: 'جارٍ الكشف',
        operationFailed: 'فشلت العملية',
        likeFailed: 'فشل الإعجاب، يرجى المحاولة مرة أخرى لاحقًا',

        // معلومات المستخدم
        unknownUser: 'غير معروف',

        // إجراءات القائمة
        download: 'تحميل',
        downloadWithWatermark: 'مع العلامة المائية',
        downloadWithoutWatermark: 'بدون العلامة المائية',
        share: 'مشاركة',
        copyLink: 'نسخ الرابط',
        report: 'إبلاغ',

        // إشعارات التحميل
        preparingDownload: 'جارٍ التحضير للتحميل...',
        downloadFailed: 'فشل التحميل، حاول مرة أخرى',
        vipRequired: 'مطلوب VIP للتحميل بدون علامة مائية',
        noWatermarkUrlNotAvailable: 'رابط التحميل بدون علامة مائية غير متوفر',
        copySuccess: 'تم النسخ بنجاح',
        copyFailed: 'فشل النسخ',
        copyLyrics: 'نسخ كلمات الأغنية',

        // صفحة التفاصيل
        originalImage: 'الأصلي',
        prompt: 'المطالبة',
        model: 'النموذج',
        style: 'النمط',
        aspectRatio: 'نسبة العرض إلى الارتفاع',
        outputSize: 'حجم الإخراج',
        tags: 'الوسوم',
        generateSimilar: 'افعل نفس الشيء',
        image: 'صورة',
        video: 'فيديو',
        creations: 'الإبداعات',
        creationDetail: 'تفاصيل الإبداع',
        aiImageCreation: 'إنشاء صورة بالذكاء الاصطناعي',
        aiVideoCreation: 'إنشاء فيديو بالذكاء الاصطناعي',
        aiMusicCreation: 'إنشاء موسيقى بالذكاء الاصطناعي',
        aiGeneratedContent: 'محتوى مُنشأ بالذكاء الاصطناعي',
        anonymous: 'مجهول',

        // أنواع الإنشاء
        imageToVideo: 'صورة إلى فيديو',
        imageToImage: 'صورة إلى صورة',
        generate: 'إنشاء',
        auto: 'تلقائي',

        // مشاركة الموسيقى
        musicStyle: 'نمط الموسيقى',
        lyrics: 'كلمات الأغنية',
        untitledMusic: 'موسيقى بدون عنوان',
        noLyrics: 'لا توجد كلمات',
        noAudio: 'لا يوجد صوت',
        referenceAudio: 'الصوت المرجعي',
        playFailed: 'فشل التشغيل، حاول مرة أخرى',
        audioLoadFailed: 'فشل تحميل الصوت',
        shareSuccess: 'تم نسخ رابط المشاركة',
        shareFailed: 'فشلت المشاركة، حاول مرة أخرى',
        noShareableContent: 'لا يوجد محتوى للمشاركة',
        copyPrompt: 'نسخ الموجه',
        noPrompt: 'لا يوجد موجه',
        type: 'نوع',
        createTime: 'وقت',
        expandDetails: 'توسيع التفاصيل',
        collapseDetails: 'طي التفاصيل',
    },
    tw: {
        // 標題
        title: '靈感',
        // 分類標籤
        categoryAll: '全部',
        categoryHot: '熱門',
        categoryLatest: '最新',
        categoryRecentlyUsed: '最近使用',
        
        // Tab 標籤
        tabHistory: '歷史',
        tabInspiration: '靈感',
        
        // 操作按鈕
        createSimilar: '創建類似圖像',
        
        // 狀態提示
        noMoreData: '沒有更多了',
        noData: '暫無資料 :D',
        noInspirationData: '暫無靈感資料',
        loading: '載入中...',
        loadingMore: '載入更多...',
        detecting: '偵測中',
        operationFailed: '操作失敗',
        likeFailed: '按讚失敗，請稍後重試',
        
        // 用戶資訊
        unknownUser: '未知用戶',
        
        // 選單操作
        download: '下載',
        downloadWithWatermark: '有浮水印下載',
        downloadWithoutWatermark: '無浮水印下載',
        share: '分享',
        copyLink: '複製連結',
        report: '檢舉',
        
        // 下載提示
        preparingDownload: '正在準備下載...',
        downloadFailed: '下載失敗，請稍後重試',
        vipRequired: '無浮水印下載需要 VIP 會員',
        noWatermarkUrlNotAvailable: '無浮水印下載連結不可用',
        copySuccess: '複製成功',
        copyFailed: '複製失敗',
        copyPrompt: '複製提示詞',
        copyLyrics: '複製歌詞',
        
        // 詳情頁
        originalImage: '原圖',
        prompt: '提示詞',
        model: '模型',
        style: '風格',
        aspectRatio: '長寬比',
        outputSize: '輸出尺寸',
        tags: '標籤',
        generateSimilar: '做同款',
        image: '圖像',
        video: '影片',
        creations: '創作',
        creationDetail: '創作詳情',
        aiImageCreation: 'AI 圖片創作',
        aiVideoCreation: 'AI 影片創作',
        aiMusicCreation: 'AI 音樂創作',
        aiGeneratedContent: 'AI 生成內容',
        anonymous: '匿名用戶',
        
        // 生成類型
        imageToVideo: '圖生影片',
        imageToImage: '圖生圖',
        generate: '生成',
        auto: '自動',
        
        // 音樂分享相關
        musicStyle: '音樂風格',
        lyrics: '歌詞',
        untitledMusic: '未命名音樂',
        noLyrics: '暫無歌詞',
        noAudio: '暫無音訊',
        referenceAudio: '參考音訊',
        playFailed: '播放失敗，請稍後重試',
        audioLoadFailed: '音訊載入失敗',
        shareSuccess: '分享連結已複製',
        shareFailed: '分享失敗，請稍後重試',
        noShareableContent: '暫無可分享內容',
        noPrompt: '暫無提示詞',
    },
    pl: {
        // Tytuł
        title: 'Inspiracja',
        // Etykiety kategorii
        categoryAll: 'Wszystkie',
        categoryHot: 'Popularne',
        categoryLatest: 'Najnowsze',
        categoryRecentlyUsed: 'Ostatnio używane',
        
        // Etykiety zakładek
        tabHistory: 'Historia',
        tabInspiration: 'Inspiracja',
        
        // Przyciski akcji
        createSimilar: 'Utwórz podobny',
        
        // Komunikaty statusu
        noMoreData: 'Brak więcej danych',
        noData: 'Brak danych :D',
        noInspirationData: 'Brak danych inspiracji',
        loading: 'Ładowanie...',
        loadingMore: 'Ładowanie więcej...',
        detecting: 'Wykrywanie',
        operationFailed: 'Operacja nie powiodła się',
        likeFailed: 'Polubienie nie powiodło się, spróbuj ponownie później',
        
        // Informacje o użytkowniku
        unknownUser: 'Nieznany',
        
        // Akcje menu
        download: 'Pobierz',
        downloadWithWatermark: 'Ze znakiem wodnym',
        downloadWithoutWatermark: 'Bez znaku wodnego',
        share: 'Udostępnij',
        copyLink: 'Kopiuj link',
        report: 'Zgłoś',
        
        // Powiadomienia o pobieraniu
        preparingDownload: 'Przygotowywanie pobierania...',
        downloadFailed: 'Pobieranie nie powiodło się, spróbuj ponownie',
        vipRequired: 'Pobieranie bez znaku wodnego wymaga członkostwa VIP',
        noWatermarkUrlNotAvailable: 'Link do pobierania bez znaku wodnego niedostępny',
        copySuccess: 'Skopiowano pomyślnie',
        copyFailed: 'Kopiowanie nie powiodło się',
        copyPrompt: 'Kopiuj prompt',
        copyLyrics: 'Kopiuj tekst',
        
        // Strona szczegółów
        originalImage: 'Oryginał',
        prompt: 'Prompt',
        model: 'Model',
        style: 'Styl',
        aspectRatio: 'Proporcje',
        outputSize: 'Rozmiar wyjściowy',
        tags: 'Tagi',
        generateSimilar: 'Remix',
        image: 'Obraz',
        video: 'Wideo',
        creations: 'Kreacje',
        creationDetail: 'Szczegóły kreacji',
        aiImageCreation: 'Kreacja obrazu AI',
        aiVideoCreation: 'Kreacja wideo AI',
        aiMusicCreation: 'Kreacja muzyki AI',
        aiGeneratedContent: 'Treść wygenerowana przez AI',
        anonymous: 'Anonimowy',
        
        // Typy generowania
        imageToVideo: 'Obraz na wideo',
        imageToImage: 'Obraz na obraz',
        generate: 'Generuj',
        auto: 'Auto',
        
        // Udostępnianie muzyki
        musicStyle: 'Styl muzyczny',
        lyrics: 'Tekst',
        untitledMusic: 'Muzyka bez tytułu',
        noLyrics: 'Brak tekstu',
        noAudio: 'Brak audio',
        referenceAudio: 'Audio referencyjne',
        playFailed: 'Odtwarzanie nie powiodło się, spróbuj ponownie',
        audioLoadFailed: 'Ładowanie audio nie powiodło się',
        shareSuccess: 'Link do udostępnienia skopiowany',
        shareFailed: 'Udostępnianie nie powiodło się, spróbuj ponownie',
        noShareableContent: 'Brak treści do udostępnienia',
        noPrompt: 'Brak promptu',
    },
    th: {
        // หัวข้อ
        title: 'แรงบันดาลใจ',
        // ป้ายหมวดหมู่
        categoryAll: 'ทั้งหมด',
        categoryHot: 'ยอดนิยม',
        categoryLatest: 'ล่าสุด',
        categoryRecentlyUsed: 'ใช้ล่าสุด',
        
        // ป้ายแท็บ
        tabHistory: 'ประวัติ',
        tabInspiration: 'แรงบันดาลใจ',
        
        // ปุ่มดำเนินการ
        createSimilar: 'สร้างคล้ายกัน',
        
        // ข้อความสถานะ
        noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
        noData: 'ไม่มีข้อมูล :D',
        noInspirationData: 'ไม่มีข้อมูลแรงบันดาลใจ',
        loading: 'กำลังโหลด...',
        loadingMore: 'กำลังโหลดเพิ่มเติม...',
        detecting: 'กำลังตรวจจับ',
        operationFailed: 'การดำเนินการล้มเหลว',
        likeFailed: 'การกดถูกใจล้มเหลว กรุณาลองใหม่ภายหลัง',
        
        // ข้อมูลผู้ใช้
        unknownUser: 'ไม่ทราบ',
        
        // การดำเนินการเมนู
        download: 'ดาวน์โหลด',
        downloadWithWatermark: 'มีลายน้ำ',
        downloadWithoutWatermark: 'ไม่มีลายน้ำ',
        share: 'แชร์',
        copyLink: 'คัดลอกลิงก์',
        report: 'รายงาน',
        
        // การแจ้งเตือนการดาวน์โหลด
        preparingDownload: 'กำลังเตรียมดาวน์โหลด...',
        downloadFailed: 'ดาวน์โหลดล้มเหลว กรุณาลองใหม่',
        vipRequired: 'ต้องเป็นสมาชิก VIP สำหรับดาวน์โหลดไม่มีลายน้ำ',
        noWatermarkUrlNotAvailable: 'ลิงก์ดาวน์โหลดไม่มีลายน้ำไม่พร้อมใช้งาน',
        copySuccess: 'คัดลอกสำเร็จ',
        copyFailed: 'คัดลอกล้มเหลว',
        copyPrompt: 'คัดลอกพรอมต์',
        copyLyrics: 'คัดลอกเนื้อเพลง',
        
        // หน้ารายละเอียด
        originalImage: 'ต้นฉบับ',
        prompt: 'พรอมต์',
        model: 'โมเดล',
        style: 'สไตล์',
        aspectRatio: 'อัตราส่วน',
        outputSize: 'ขนาดเอาต์พุต',
        tags: 'แท็ก',
        generateSimilar: 'รีมิกซ์',
        image: 'รูปภาพ',
        video: 'วิดีโอ',
        creations: 'ผลงาน',
        creationDetail: 'รายละเอียดผลงาน',
        aiImageCreation: 'การสร้างภาพ AI',
        aiVideoCreation: 'การสร้างวิดีโอ AI',
        aiMusicCreation: 'การสร้างเพลง AI',
        aiGeneratedContent: 'เนื้อหาที่สร้างโดย AI',
        anonymous: 'ไม่ระบุชื่อ',
        
        // ประเภทการสร้าง
        imageToVideo: 'ภาพเป็นวิดีโอ',
        imageToImage: 'ภาพเป็นภาพ',
        generate: 'สร้าง',
        auto: 'อัตโนมัติ',
        
        // การแชร์เพลง
        musicStyle: 'สไตล์เพลง',
        lyrics: 'เนื้อเพลง',
        untitledMusic: 'เพลงไม่มีชื่อ',
        noLyrics: 'ไม่มีเนื้อเพลง',
        noAudio: 'ไม่มีเสียง',
        referenceAudio: 'เสียงอ้างอิง',
        playFailed: 'เล่นล้มเหลว กรุณาลองใหม่',
        audioLoadFailed: 'โหลดเสียงล้มเหลว',
        shareSuccess: 'คัดลอกลิงก์แชร์แล้ว',
        shareFailed: 'แชร์ล้มเหลว กรุณาลองใหม่',
        noShareableContent: 'ไม่มีเนื้อหาที่แชร์ได้',
        noPrompt: 'ไม่มีพรอมต์',
    },
    da: {
        // Titel
        title: 'Inspiration',
        // Kategorimærker
        categoryAll: 'Alle',
        categoryHot: 'Populære',
        categoryLatest: 'Seneste',
        categoryRecentlyUsed: 'Senest brugt',
        
        // Fanemærker
        tabHistory: 'Historik',
        tabInspiration: 'Inspiration',
        
        // Handlingsknapper
        createSimilar: 'Opret lignende',
        
        // Statusmeddelelser
        noMoreData: 'Ingen flere data',
        noData: 'Ingen data tilgængelig :D',
        noInspirationData: 'Ingen inspirationsdata',
        loading: 'Indlæser...',
        loadingMore: 'Indlæser mere...',
        detecting: 'Registrerer',
        operationFailed: 'Handling mislykkedes',
        likeFailed: 'Like mislykkedes, prøv igen senere',
        
        // Brugerinfo
        unknownUser: 'Ukendt',
        
        // Menuhandlinger
        download: 'Download',
        downloadWithWatermark: 'Med vandmærke',
        downloadWithoutWatermark: 'Uden vandmærke',
        share: 'Del',
        copyLink: 'Kopiér link',
        report: 'Rapportér',
        
        // Downloadmeddelelser
        preparingDownload: 'Forbereder download...',
        downloadFailed: 'Download mislykkedes, prøv igen',
        vipRequired: 'VIP-medlemskab kræves for download uden vandmærke',
        noWatermarkUrlNotAvailable: 'Download-link uden vandmærke ikke tilgængeligt',
        copySuccess: 'Kopieret',
        copyFailed: 'Kopiering mislykkedes',
        copyPrompt: 'Kopiér prompt',
        copyLyrics: 'Kopiér tekst',
        
        // Detaljeside
        originalImage: 'Original',
        prompt: 'Prompt',
        model: 'Model',
        style: 'Stil',
        aspectRatio: 'Billedformat',
        outputSize: 'Outputstørrelse',
        tags: 'Tags',
        generateSimilar: 'Remix',
        image: 'Billede',
        video: 'Video',
        creations: 'Kreationer',
        creationDetail: 'Kreationsdetaljer',
        aiImageCreation: 'AI-billedoprettelse',
        aiVideoCreation: 'AI-videooprettelse',
        aiMusicCreation: 'AI-musikoprettelse',
        aiGeneratedContent: 'AI-genereret indhold',
        anonymous: 'Anonym',
        
        // Genereringstyper
        imageToVideo: 'Billede til video',
        imageToImage: 'Billede til billede',
        generate: 'Generér',
        auto: 'Auto',
        
        // Musikdeling
        musicStyle: 'Musikstil',
        lyrics: 'Tekst',
        untitledMusic: 'Unavngivet musik',
        noLyrics: 'Ingen tekst tilgængelig',
        noAudio: 'Ingen lyd tilgængelig',
        referenceAudio: 'Referencelyd',
        playFailed: 'Afspilning mislykkedes, prøv igen',
        audioLoadFailed: 'Lydindlæsning mislykkedes',
        shareSuccess: 'Delingslink kopieret',
        shareFailed: 'Deling mislykkedes, prøv igen',
        noShareableContent: 'Intet indhold at dele',
        noPrompt: 'Ingen prompt tilgængelig',
    },
    no: {
        // Tittel
        title: 'Inspirasjon',
        // Kategorietiketter
        categoryAll: 'Alle',
        categoryHot: 'Populære',
        categoryLatest: 'Nyeste',
        categoryRecentlyUsed: 'Nylig brukt',
        
        // Faneetiketter
        tabHistory: 'Historikk',
        tabInspiration: 'Inspirasjon',
        
        // Handlingsknapper
        createSimilar: 'Opprett lignende',
        
        // Statusmeldinger
        noMoreData: 'Ingen flere data',
        noData: 'Ingen data tilgjengelig :D',
        noInspirationData: 'Ingen inspirasjonsdata',
        loading: 'Laster...',
        loadingMore: 'Laster mer...',
        detecting: 'Oppdager',
        operationFailed: 'Handling mislyktes',
        likeFailed: 'Liking mislyktes, prøv igjen senere',
        
        // Brukerinfo
        unknownUser: 'Ukjent',
        
        // Menyhandlinger
        download: 'Last ned',
        downloadWithWatermark: 'Med vannmerke',
        downloadWithoutWatermark: 'Uten vannmerke',
        share: 'Del',
        copyLink: 'Kopier lenke',
        report: 'Rapporter',
        
        // Nedlastingsmeldinger
        preparingDownload: 'Forbereder nedlasting...',
        downloadFailed: 'Nedlasting mislyktes, prøv igjen',
        vipRequired: 'VIP-medlemskap kreves for nedlasting uten vannmerke',
        noWatermarkUrlNotAvailable: 'Nedlastingslenke uten vannmerke ikke tilgjengelig',
        copySuccess: 'Kopiert',
        copyFailed: 'Kopiering mislyktes',
        copyPrompt: 'Kopier prompt',
        copyLyrics: 'Kopier tekst',
        
        // Detaljeside
        originalImage: 'Original',
        prompt: 'Prompt',
        model: 'Modell',
        style: 'Stil',
        aspectRatio: 'Bildeformat',
        outputSize: 'Utdatastørrelse',
        tags: 'Tagger',
        generateSimilar: 'Remix',
        image: 'Bilde',
        video: 'Video',
        creations: 'Kreasjoner',
        creationDetail: 'Kreasjonsdetaljer',
        aiImageCreation: 'AI-bildeoppretting',
        aiVideoCreation: 'AI-videooppretting',
        aiMusicCreation: 'AI-musikkoppretting',
        aiGeneratedContent: 'AI-generert innhold',
        anonymous: 'Anonym',
        
        // Genereringstyper
        imageToVideo: 'Bilde til video',
        imageToImage: 'Bilde til bilde',
        generate: 'Generer',
        auto: 'Auto',
        
        // Musikkdeling
        musicStyle: 'Musikkstil',
        lyrics: 'Tekst',
        untitledMusic: 'Navnløs musikk',
        noLyrics: 'Ingen tekst tilgjengelig',
        noAudio: 'Ingen lyd tilgjengelig',
        referenceAudio: 'Referanselyd',
        playFailed: 'Avspilling mislyktes, prøv igjen',
        audioLoadFailed: 'Lydlasting mislyktes',
        shareSuccess: 'Delingslenke kopiert',
        shareFailed: 'Deling mislyktes, prøv igjen',
        noShareableContent: 'Ingen delbart innhold',
        noPrompt: 'Ingen prompt tilgjengelig',
    },
    nl: {
        // Titel
        title: 'Inspiratie',
        // Categorielabels
        categoryAll: 'Alles',
        categoryHot: 'Populair',
        categoryLatest: 'Nieuwste',
        categoryRecentlyUsed: 'Recent gebruikt',
        
        // Tablabels
        tabHistory: 'Geschiedenis',
        tabInspiration: 'Inspiratie',
        
        // Actieknoppen
        createSimilar: 'Maak vergelijkbaar',
        
        // Statusberichten
        noMoreData: 'Geen meer gegevens',
        noData: 'Geen gegevens beschikbaar :D',
        noInspirationData: 'Geen inspiratiegegevens',
        loading: 'Laden...',
        loadingMore: 'Meer laden...',
        detecting: 'Detecteren',
        operationFailed: 'Bewerking mislukt',
        likeFailed: 'Like mislukt, probeer het later opnieuw',
        
        // Gebruikersinfo
        unknownUser: 'Onbekend',
        
        // Menuacties
        download: 'Downloaden',
        downloadWithWatermark: 'Met watermerk',
        downloadWithoutWatermark: 'Zonder watermerk',
        share: 'Delen',
        copyLink: 'Link kopiëren',
        report: 'Rapporteren',
        
        // Downloadmeldingen
        preparingDownload: 'Download voorbereiden...',
        downloadFailed: 'Download mislukt, probeer opnieuw',
        vipRequired: 'VIP-lidmaatschap vereist voor download zonder watermerk',
        noWatermarkUrlNotAvailable: 'Downloadlink zonder watermerk niet beschikbaar',
        copySuccess: 'Gekopieerd',
        copyFailed: 'Kopiëren mislukt',
        copyPrompt: 'Prompt kopiëren',
        copyLyrics: 'Tekst kopiëren',
        
        // Detailpagina
        originalImage: 'Origineel',
        prompt: 'Prompt',
        model: 'Model',
        style: 'Stijl',
        aspectRatio: 'Beeldverhouding',
        outputSize: 'Uitvoergrootte',
        tags: 'Tags',
        generateSimilar: 'Remix',
        image: 'Afbeelding',
        video: 'Video',
        creations: 'Creaties',
        creationDetail: 'Creatiedetails',
        aiImageCreation: 'AI-afbeeldingcreatie',
        aiVideoCreation: 'AI-videocreatie',
        aiMusicCreation: 'AI-muziekcreatie',
        aiGeneratedContent: 'AI-gegenereerde inhoud',
        anonymous: 'Anoniem',
        
        // Generatietypen
        imageToVideo: 'Afbeelding naar video',
        imageToImage: 'Afbeelding naar afbeelding',
        generate: 'Genereren',
        auto: 'Auto',
        
        // Muziek delen
        musicStyle: 'Muziekstijl',
        lyrics: 'Tekst',
        untitledMusic: 'Naamloze muziek',
        noLyrics: 'Geen tekst beschikbaar',
        noAudio: 'Geen audio beschikbaar',
        referenceAudio: 'Referentieaudio',
        playFailed: 'Afspelen mislukt, probeer opnieuw',
        audioLoadFailed: 'Audio laden mislukt',
        shareSuccess: 'Deellink gekopieerd',
        shareFailed: 'Delen mislukt, probeer opnieuw',
        noShareableContent: 'Geen deelbare inhoud',
        noPrompt: 'Geen prompt beschikbaar',
    },
    id: {
        // Judul
        title: 'Inspirasi',
        // Label kategori
        categoryAll: 'Semua',
        categoryHot: 'Populer',
        categoryLatest: 'Terbaru',
        categoryRecentlyUsed: 'Baru digunakan',
        
        // Label tab
        tabHistory: 'Riwayat',
        tabInspiration: 'Inspirasi',
        
        // Tombol aksi
        createSimilar: 'Buat serupa',
        
        // Pesan status
        noMoreData: 'Tidak ada data lagi',
        noData: 'Tidak ada data :D',
        noInspirationData: 'Tidak ada data inspirasi',
        loading: 'Memuat...',
        loadingMore: 'Memuat lebih banyak...',
        detecting: 'Mendeteksi',
        operationFailed: 'Operasi gagal',
        likeFailed: 'Gagal menyukai, coba lagi nanti',
        
        // Info pengguna
        unknownUser: 'Tidak dikenal',
        
        // Aksi menu
        download: 'Unduh',
        downloadWithWatermark: 'Dengan watermark',
        downloadWithoutWatermark: 'Tanpa watermark',
        share: 'Bagikan',
        copyLink: 'Salin tautan',
        report: 'Laporkan',
        
        // Notifikasi unduhan
        preparingDownload: 'Menyiapkan unduhan...',
        downloadFailed: 'Unduhan gagal, coba lagi',
        vipRequired: 'Keanggotaan VIP diperlukan untuk unduhan tanpa watermark',
        noWatermarkUrlNotAvailable: 'Tautan unduhan tanpa watermark tidak tersedia',
        copySuccess: 'Berhasil disalin',
        copyFailed: 'Gagal menyalin',
        copyPrompt: 'Salin prompt',
        copyLyrics: 'Salin lirik',
        
        // Halaman detail
        originalImage: 'Asli',
        prompt: 'Prompt',
        model: 'Model',
        style: 'Gaya',
        aspectRatio: 'Rasio aspek',
        outputSize: 'Ukuran output',
        tags: 'Tag',
        generateSimilar: 'Remix',
        image: 'Gambar',
        video: 'Video',
        creations: 'Kreasi',
        creationDetail: 'Detail kreasi',
        aiImageCreation: 'Kreasi gambar AI',
        aiVideoCreation: 'Kreasi video AI',
        aiMusicCreation: 'Kreasi musik AI',
        aiGeneratedContent: 'Konten yang dihasilkan AI',
        anonymous: 'Anonim',
        
        // Jenis pembuatan
        imageToVideo: 'Gambar ke video',
        imageToImage: 'Gambar ke gambar',
        generate: 'Buat',
        auto: 'Otomatis',
        
        // Berbagi musik
        musicStyle: 'Gaya musik',
        lyrics: 'Lirik',
        untitledMusic: 'Musik tanpa judul',
        noLyrics: 'Tidak ada lirik',
        noAudio: 'Tidak ada audio',
        referenceAudio: 'Audio referensi',
        playFailed: 'Pemutaran gagal, coba lagi',
        audioLoadFailed: 'Gagal memuat audio',
        shareSuccess: 'Tautan berbagi disalin',
        shareFailed: 'Gagal berbagi, coba lagi',
        noShareableContent: 'Tidak ada konten yang dapat dibagikan',
        noPrompt: 'Tidak ada prompt',
    },
    tr: {
        // Başlık
        title: 'İlham',
        // Kategori etiketleri
        categoryAll: 'Tümü',
        categoryHot: 'Popüler',
        categoryLatest: 'En Yeni',
        categoryRecentlyUsed: 'Son Kullanılan',
        
        // Sekme etiketleri
        tabHistory: 'Geçmiş',
        tabInspiration: 'İlham',
        
        // Eylem düğmeleri
        createSimilar: 'Benzer oluştur',
        
        // Durum mesajları
        noMoreData: 'Daha fazla veri yok',
        noData: 'Veri yok :D',
        noInspirationData: 'İlham verisi yok',
        loading: 'Yükleniyor...',
        loadingMore: 'Daha fazla yükleniyor...',
        detecting: 'Algılanıyor',
        operationFailed: 'İşlem başarısız',
        likeFailed: 'Beğeni başarısız, daha sonra tekrar deneyin',
        
        // Kullanıcı bilgisi
        unknownUser: 'Bilinmeyen',
        
        // Menü eylemleri
        download: 'İndir',
        downloadWithWatermark: 'Filigran ile',
        downloadWithoutWatermark: 'Filigransız',
        share: 'Paylaş',
        copyLink: 'Bağlantıyı kopyala',
        report: 'Bildir',
        
        // İndirme bildirimleri
        preparingDownload: 'İndirme hazırlanıyor...',
        downloadFailed: 'İndirme başarısız, tekrar deneyin',
        vipRequired: 'Filigransız indirme için VIP üyelik gerekli',
        noWatermarkUrlNotAvailable: 'Filigransız indirme bağlantısı mevcut değil',
        copySuccess: 'Kopyalandı',
        copyFailed: 'Kopyalama başarısız',
        copyPrompt: 'Promptu kopyala',
        copyLyrics: 'Şarkı sözlerini kopyala',
        
        // Detay sayfası
        originalImage: 'Orijinal',
        prompt: 'Prompt',
        model: 'Model',
        style: 'Stil',
        aspectRatio: 'En-boy oranı',
        outputSize: 'Çıktı boyutu',
        tags: 'Etiketler',
        generateSimilar: 'Remix',
        image: 'Görsel',
        video: 'Video',
        creations: 'Kreasyonlar',
        creationDetail: 'Kreasyon detayı',
        aiImageCreation: 'AI görsel oluşturma',
        aiVideoCreation: 'AI video oluşturma',
        aiMusicCreation: 'AI müzik oluşturma',
        aiGeneratedContent: 'AI tarafından oluşturulan içerik',
        anonymous: 'Anonim',
        
        // Oluşturma türleri
        imageToVideo: 'Görselden videoya',
        imageToImage: 'Görselden görsele',
        generate: 'Oluştur',
        auto: 'Otomatik',
        
        // Müzik paylaşımı
        musicStyle: 'Müzik stili',
        lyrics: 'Şarkı sözleri',
        untitledMusic: 'Adsız müzik',
        noLyrics: 'Şarkı sözü yok',
        noAudio: 'Ses yok',
        referenceAudio: 'Referans ses',
        playFailed: 'Oynatma başarısız, tekrar deneyin',
        audioLoadFailed: 'Ses yüklenemedi',
        shareSuccess: 'Paylaşım bağlantısı kopyalandı',
        shareFailed: 'Paylaşım başarısız, tekrar deneyin',
        noShareableContent: 'Paylaşılacak içerik yok',
        noPrompt: 'Prompt yok',
    },
}
